module.exports = __webpack_public_path__ + "static/img/0547_9.40b09f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_9.jpg
// module id = n12r
// module chunks = 1